import { createSelector, createSlice } from '@reduxjs/toolkit';
import { getBlog, getPost, getPosts } from 'api/Blog';
import { fetchWithLanguage } from '../helpers';

export const fetchPost = fetchWithLanguage('fetchPost', getPost);
export const fetchPosts = fetchWithLanguage('fetchPosts', getPosts);
export const fetchBlog = fetchWithLanguage('fetchBlog', getBlog);

const blogSlice = createSlice({
    name: 'blogSlice',
    initialState: {
        blog: {},
        postsList: [],
        postsContent: {},
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchPosts.fulfilled, (state, action) => {
                state.postsList = action.payload;
            })
            .addCase(fetchBlog.fulfilled, (state, action) => {
                state.blog = action.payload;
            })
            .addCase(fetchPost.fulfilled, (state, action) => {
                const newItemKey = action.payload.data.slug;

                const newItem = {
                    [newItemKey]: action.payload.data,
                };

                state.postsContent = {
                    ...state.postsContent,
                    ...newItem,
                };
            });
    },
});

export const selectBlogPage = createSelector([state => state.blogState.blog], blog => blog.data || {});

export const selectPostsContent = createSelector([state => state.blogState.postsContent], data => data);

export default blogSlice.reducer;
